type LoadingListener = () => void;

let pendingRequests = 0;
const listeners = new Set<LoadingListener>();

function notifyListeners(): void {
  listeners.forEach(listener => listener());
}

export function onHttpRequestStart(): void {
  pendingRequests += 1;
  notifyListeners();
}

export function onHttpRequestEnd(): void {
  pendingRequests = Math.max(0, pendingRequests - 1);
  notifyListeners();
}

export function getPendingHttpRequests(): number {
  return pendingRequests;
}

export function subscribeHttpLoading(listener: LoadingListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

